import {
	Alert,
	Button,
	Collapse,
	DatePicker,
	Form,
	Input,
	Modal,
	Popconfirm,
	Select,
	Spin,
	Tabs,
	Upload,
	message,
} from 'antd';
import dayjs from 'dayjs';
import _, { get } from 'lodash';
import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { gql } from '@apollo/client';
import { CSVLink } from 'react-csv';
import ReactGA from 'react-ga';
import { configMode } from 'src/_shared/api/';
import { queryCampaignsByCompanyIdIndex } from 'src/_shared/api/graphql/custom/bonus-campaign/';
import {
	queryJobsByCampaignIdIndex,
	queryJobsByCompanyIdStatusIndex,
} from 'src/_shared/api/graphql/custom/jobs/';
import { querySubCompanyByCompanyIdIndex } from 'src/_shared/api/graphql/custom/sub-company/';
import Spinner from 'src/_shared/components/spinner/SpinnerComponent.jsx';
import {
	formatDate,
	getSetErrorImageURL,
	lambda,
	logout,
	ml,
	parse,
} from 'src/_shared/services/utils.js';
import {
	jobsMissingOwnTieredBonus,
	uncoveredUserGroups,
} from 'src/_shared/services/tieredBonus.js';
import { COLORS } from 'src/_shared/styles/colors.js';
import fileIcon from '../_shared/assets/erin_lightgray.png';

const QUERY_JOBS_BY_SUBCOMPANY_ID = gql`
	query QueryJobsBySubCompanyIdIndex(
		$subCompanyId: ID!
		$first: Int
		$after: String
	) {
		queryJobsBySubCompanyIdIndex(
			subCompanyId: $subCompanyId
			first: $first
			after: $after
		) {
			nextToken
			items {
				id
				status
			}
		}
	}
`;

const QUERY_JOBS_BY_DEPARTMENT_ID = gql`
	query QueryJobsByDepartmentIdIndex(
		$departmentId: ID!
		$first: Int
		$after: String
	) {
		queryJobsByDepartmentIdIndex(
			departmentId: $departmentId
			first: $first
			after: $after
		) {
			nextToken
			items {
				id
				status
			}
		}
	}
`;

const QUERY_JOBS_BY_COMPANY_ID_EXTERNAL_IDS = gql`
	query QueryJobsByCompanyIdExternalIds(
		$companyId: ID!
		$externalJobIds: [String]
		$includeClosedJobs: Boolean
	) {
		queryJobsByCompanyIdExternalIds(
			companyId: $companyId
			externalJobIds: $externalJobIds
			includeClosedJobs: $includeClosedJobs
		) {
			items {
				id
				departmentId
				externalJobId
				subCompanyId
				title
				status
				location
				jobAdditionalInfo
				hiringManagerId
				hiringManager {
					id
					firstName
					lastName
				}
			}
		}
	}
`;

class BonusCampaignsComponent extends Component {
	constructor(props) {
		super(props);
		this.jobsFormRef = React.createRef();
		this.bonusFormRef = React.createRef();
		this.state = {
			theme: JSON.parse(get(props, 'currentUser.company.theme', '{}')),
			filteredDepartments: [],
			filteredUserGroups: [],
			filteredJobs: [],
			filteredStates: [],
			filteredCountries: [],
			filteredHiringManagers: [],
			filteredCompGrades: [],
			// Derived once from allJobs so we never re-parse location/jobAdditionalInfo on render.
			jobFacets: {}, // { jobId: { state, country, hiringManagerId, compGrade } }
			stateOptions: [],
			countryOptions: [],
			hiringManagerOptions: [],
			compGradeOptions: [],
			allJobs: [],
			filteredUsers: [],
			usersCount: 0,
			subject: '',
			message: '',
			lengthError: false,
			loaded: false,
			jobId: '',
			jobTitle: '',
			jobLocation: '',
			// True until every page of company jobs has been fetched. Large companies can take up
			// to a minute, and the bulk filters below are derived from the full list.
			jobsLoading: true,
			jobDefaultValue: 'None',
			buttonState: '',
			isTestEmailDone: '',
			isEmailAllUsers: '',
			isSubjectEmpty: false,
			isMessageEmpty: false,
			filteredSubCompanies: [],
			ml_SendAMessage: '',
			ml_SelectEmployees: '',
			ml_WhoWill: '',
			ml_InGroup: '',
			ml_AndInDept: '',
			ml_All: '',
			ml_None: '',
			ml_EmpSelected: '',
			ml_Job: '',
			ml_Optional: '',
			ml_DoYouWant: '',
			ml_MessageCenter_SelectJob: '',
			ml_Message: '',
			ml_TheMessage: '',
			ml_Subject: '',
			ml_SendMe: '',
			ml_MessageCenter_Email: '',
			ml_Employees: '',
			ml_Location: 'Location',
			ml_withIn: 'within',
			ml_of: 'of',
			ml_Location_Note:
				'Note: Location filter will only send messages to users with a set location.',
			ml_miles: 'Miles',
			ml_city: 'City',
			ml_state: 'State',
			location: {
				city: '',
				state: '',
				lat: '',
				lng: '',
				address: '',
			},
			filteredDistance: '0',
			ml_AllLocations: 'All Locations',
			isEmployee: true,
			isCandidate: false,
			dateRangeFilterValue: [dayjs().startOf('month'), null],
			filteredCandidateData: [],
			filteredCount: 0,
			totalReferralsData: [],
			totalReferralsCount: 0,
			countLoaded: true,
			isEmailAllCandidates: '',
			ml_MessageCenter_SelectBrand: '',
			subCompanies: [],
			subCompany: {},
			sendPush: false,
			bonuses: get(props, 'bonuses', []),
			jobsCount: 0,
			disabled: true,
			selectedJobsByUser: [],
			onlySelectedJobs: [],
			defaultSubCompaniesValue: undefined,
			allCampaignsData: get(props, 'campaigns', []),
			allCampaigns: [],
			success: false,
			edit: false,
			editCampaignId: null,
			editedJob: [],
			editTieredBonusId: null,
			editDateRangeFilterValue: [dayjs().startOf('month'), null],
			btnDisabled: false,
			jobError: false,
			editJobReq: false,
			editTieredBonusReq: false,
			editBonusScheduleReq: false,
			markHot: false,
			makeHotJob: false,
			errorImageURL: '',
			cachedDepartmentJobs: {}, // { departmentId: [jobId1, jobId2, ...] }
			cachedSubCompanyJobs: {}, // { subCompanyId: [jobId1, jobId2, ...] }
			csvFile: null,
			csvColumns: [],
			selectedColumn: null,
			csvParsedData: [],
			csvJobsLoading: false,
			includeClosedJobs: false,
			// Update Jobs from CSV modal state
			updateCsvModalVisible: false,
			updateCsvCampaign: null,
			updateCsvFile: null,
			updateCsvColumns: [],
			updateCsvSelectedColumn: null,
			updateCsvParsedData: [],
			updateCsvJobsLoading: false,
			updateCsvIncludeClosedJobs: false,
			updateCsvNewJobs: [],
			updateCsvExistingJobs: [],
			updateCsvRemovedJobs: [],
			updateCsvResultsReady: false,
			updateCsvFoundJobs: [],
			updateCsvMarkHot: false,
			updateCsvRemoveJobs: false,
			updateCsvUpdating: false,
		};
		this.loading = true;
	}

	async componentDidMount() {
		const host = window.location.hostname;
		if (host === 'referrals.aus.com') {
			ReactGA.initialize('UA-128630809-2');
			ReactGA.pageview(window.location.pathname + window.location.search);
		} else if (host === 'app.erinapp.com') {
			ReactGA.initialize('UA-128630809-3');
			ReactGA.pageview(window.location.pathname + window.location.search);
		}

		let endpoint = '';
		endpoint = configMode === 'DEV' ? 'dev-campaigns' : 'prod-campaigns';
		const companyId = get(this.props.currentUser, 'companyId');
		await lambda({ endpoint, variables: { companyId } });
		await this.getAllCampaignsByCompany();
		this.loading = false;
		await this.getJobs();
		await this.getSubCompaniesByCompany();

		const { currentUser } = this.props;
		const errorImageURL = await getSetErrorImageURL(
			currentUser?.company?.errorImage?.key
		);

		if (errorImageURL) {
			this.setState({ errorImageURL });
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.bonuses !== this.props.bonuses) {
			const updatedBonuses = get(this.props, 'bonuses', []);
			this.setState({
				bonuses: updatedBonuses,
			});
		}
	}

	getAllCampaignsByCompany = async (
		policy = 'network-only',
		nextToken = null,
		allCampaigns = []
	) => {
		const { client, currentUser } = this.props;
		try {
			const { data } = await client.query({
				query: gql(queryCampaignsByCompanyIdIndex),
				variables: {
					companyId: get(currentUser, 'companyId'),
					after: nextToken,
				},
				fetchPolicy: policy,
			});
			const allCampaignsData = [...data.queryCampaignsByCompanyIdIndex.items];
			const token = get(data, 'queryCampaignsByCompanyIdIndex.nextToken', null);
			allCampaigns = [...allCampaigns, ...allCampaignsData];
			this.setState({
				allCampaigns,
			});

			if (token) {
				await this.getAllCampaignsByCompany(policy, token, allCampaigns);
			}
		} catch (error) {
			console.log(error);
		}
	};

	async getJobs(policy = 'network-only', nextToken = null, allJobs = []) {
		const { client, currentUser } = this.props;
		try {
			const { data } = await client.query({
				query: gql(queryJobsByCompanyIdStatusIndex),
				variables: {
					companyId: get(currentUser, 'companyId'),
					after: nextToken,
					status: 'open',
				},
				fetchPolicy: policy,
			});
			const jobs = [...data.queryJobsByCompanyIdStatusIndex.items];
			const token = get(
				data,
				'queryJobsByCompanyIdStatusIndex.nextToken',
				null
			);
			allJobs = [...allJobs, ...jobs];
			// Set on every page so the loading indicator can show live progress.
			this.setState({
				allJobs,
			});
			if (token) {
				this.getJobs(policy, token, allJobs);
			} else {
				this.setState({ jobsLoading: false });
				this.buildJobFacets(allJobs);
			}
		} catch (error) {
			console.log(error);
			// Otherwise the filters stay behind a spinner that never resolves.
			this.setState({ jobsLoading: false });
		}
	}

	/*
	 * The state/country/hiring manager/compensation grade filters all read values that live inside
	 * AWSJSON blobs (location, jobAdditionalInfo). Parse each job once when the job list finishes
	 * loading and keep a flat facet record per job id, so filtering and rendering never re-parse.
	 * The option lists are built from the loaded jobs themselves, which means an option can never
	 * appear that matches zero open jobs.
	 */
	buildJobFacets = (allJobs = []) => {
		const jobFacets = {};
		const states = new Map();
		const countries = new Map();
		const hiringManagers = new Map();
		const compGrades = new Map();

		for (const job of allJobs) {
			const location = parse(get(job, 'location')) || {};
			const additionalInfo = parse(get(job, 'jobAdditionalInfo')) || {};
			const state = get(location, 'state') || null;
			const country = get(location, 'country') || null;
			const hiringManagerId = get(job, 'hiringManagerId') || null;
			const compGrade = get(additionalInfo, 'compensationGrade') || null;

			jobFacets[job.id] = { state, country, hiringManagerId, compGrade };

			if (state) states.set(state, state);
			// Label with the readable name when we have it, but key on the stored country value.
			if (country)
				countries.set(country, get(location, 'countryName') || country);
			if (hiringManagerId) {
				const name = `${get(job, 'hiringManager.firstName', '')} ${get(
					job,
					'hiringManager.lastName',
					''
				)}`.trim();
				if (name) hiringManagers.set(hiringManagerId, name);
			}

			if (compGrade) compGrades.set(compGrade, compGrade);
		}

		const toOptions = (map) =>
			[...map.entries()]
				.map(([value, label]) => ({ value, label }))
				.sort((a, b) => a.label.localeCompare(b.label));

		this.setState({
			jobFacets,
			stateOptions: toOptions(states),
			countryOptions: toOptions(countries),
			hiringManagerOptions: toOptions(hiringManagers),
			compGradeOptions: toOptions(compGrades),
		});
	};

	fetchJobsByDepartmentId = async (departmentId) => {
		const { client } = this.props;
		const allJobIds = [];
		let nextToken = null;

		try {
			do {
				const { data } = await client.query({
					query: QUERY_JOBS_BY_DEPARTMENT_ID,
					variables: {
						departmentId,
						first: 1000,
						after: nextToken,
					},
					fetchPolicy: 'network-only',
				});
				const jobIds = get(data, 'queryJobsByDepartmentIdIndex.items', [])
					.filter((job) => job?.status === 'open')
					.map((job) => job.id);
				allJobIds.push(...jobIds);

				nextToken = get(data, 'queryJobsByDepartmentIdIndex.nextToken', null);
			} while (nextToken);

			return allJobIds;
		} catch (error) {
			console.error('Error fetching jobs by department ID:', error);
			return [];
		}
	};

	fetchJobsBySubCompanyId = async (subCompanyId) => {
		const { client } = this.props;
		const allJobIds = [];
		let nextToken = null;

		try {
			do {
				const { data } = await client.query({
					query: QUERY_JOBS_BY_SUBCOMPANY_ID,
					variables: {
						subCompanyId,
						first: 1000,
						after: nextToken,
					},
					fetchPolicy: 'network-only',
				});

				const jobIds = get(data, 'queryJobsBySubCompanyIdIndex.items', [])
					.filter((job) => job?.status === 'open')
					.map((job) => job.id);
				allJobIds.push(...jobIds);

				nextToken = get(data, 'queryJobsBySubCompanyIdIndex.nextToken', null);
			} while (nextToken);

			return allJobIds;
		} catch (error) {
			console.error('Error fetching jobs by subCompany ID:', error);
			return [];
		}
	};

	getJobsCSVData = () => {
		const tableData = get(this.state, 'selectedJobsByUser', []);
		const newData = [];
		if (tableData.length > 0) {
			for (const item of tableData) {
				// Same AWSJSON blobs the Select Jobs facet filters read from.
				const location = parse(get(item, 'location')) || {};
				const additionalInfo = parse(get(item, 'jobAdditionalInfo')) || {};
				const hiringManager =
					`${get(item, 'hiringManager.firstName', '')} ${get(
						item,
						'hiringManager.lastName',
						''
					)}`.trim();
				const newItem = {
					title: get(item, 'title', ''),
					department: get(item, 'department.name', ''),
					subcompany: get(item, 'subCompany.name', ''),
					workState: get(location, 'state') || '',
					country:
						get(location, 'countryName') || get(location, 'country') || '',
					hiringManager,
					compensationGrade: get(additionalInfo, 'compensationGrade') || '',
					status: get(item, 'status'),
				};
				newData.push(newItem);
			}
		}

		return newData;
	};

	getSubCompaniesByCompany = async (
		policy = 'network-only',
		nextToken = null,
		subCompanies = []
	) => {
		const { client, currentUser } = this.props;
		try {
			const { data } = await client.query({
				query: gql(querySubCompanyByCompanyIdIndex),
				variables: {
					companyId: get(currentUser, 'companyId'),
					after: nextToken,
				},
				fetchPolicy: policy,
			});
			const SubCompanyByCompanies = [
				...data.querySubCompanyByCompanyIdIndex.items,
			];
			const token = get(
				data,
				'querySubCompanyByCompanyIdIndex.nextToken',
				null
			);
			subCompanies = [...subCompanies, ...SubCompanyByCompanies];
			this.setState({
				subCompanies,
			});

			if (token) {
				this.getSubCompaniesByCompany(policy, token, subCompanies);
			}
		} catch (error) {
			console.log(error);
		}
	};

	JobItem = (campaignId, tieredBonusId, multiSelectDefaultValue) => {
		const removeJob = (jobId, jobTitle) => {
			const job = {
				value: jobId,
				label: jobTitle,
			};
			this.updateCampaign(
				campaignId,
				tieredBonusId,
				job,
				multiSelectDefaultValue
			);
		};

		return (
			<>
				{multiSelectDefaultValue
					? multiSelectDefaultValue.map((job) => {
							return (
								<li key={job.value + '-' + job.label} className="tag green">
									<span className="tag-name"> {job.label} </span>
									<Popconfirm
										placement="left"
										title="Are you sure？"
										okText="Delete"
										cancelText="Cancel"
										onConfirm={() => removeJob(job.value, job.label)}
									>
										<i className="tag-close icon-cross" />
									</Popconfirm>
								</li>
							);
						})
					: null}
			</>
		);
	};

	JobsCsvheader = [
		{ label: 'Job Title', key: 'title' },
		{ label: 'Department', key: 'department' },
		{ label: 'Subcompany', key: 'subcompany' },
		{ label: 'Work State/Province', key: 'workState' },
		{ label: 'Country', key: 'country' },
		{ label: 'Hiring Manager', key: 'hiringManager' },
		{ label: 'Compensation Grade', key: 'compensationGrade' },
		{ label: 'Status', key: 'status' },
	];

	bonusSchedule = () => {
		const { bonuses } = this.state;
		const { currentUser, allMultiLingualData } = this.props;
		const { RangePicker } = DatePicker;
		const sortedBonuses = _.sortBy(bonuses, ['name']);
		const bonusOptions = sortedBonuses.map((bonus) => {
			return { value: bonus.id, label: bonus.name };
		});
		return (
			<Form ref={this.bonusFormRef}>
				<h4 className="campaign-title">
					Step 2. {ml('Bonus Schedule', currentUser, allMultiLingualData)}
				</h4>
				<div className="campaign-form-wrap">
					<div className="bs-form">
						<div className="custom-form-group">
							<label className="bs-form-label">
								{ml('Schedule Name', currentUser, allMultiLingualData)}:
							</label>
							<Form.Item
								name="scheduleName"
								rules={[
									{
										required: true,
										message: 'Please input Schedule Name',
									},
								]}
							>
								<Input className="custom-input" />
							</Form.Item>
						</div>
						<div className="custom-form-group">
							<label className="bs-form-label">
								{ml('Temporary Bonus', currentUser, allMultiLingualData)}:
							</label>
							<Form.Item
								name="tieredBonus"
								rules={[
									{
										required: true,
										message: 'Please select Tiered Bonus',
									},
								]}
							>
								<Select
									filterOption={(input, option) => {
										return option.label
											.toLowerCase()
											.includes(input.toLowerCase());
									}}
									className="custom-input"
									placeholder={ml(
										'Choose a Bonus',
										currentUser,
										allMultiLingualData
									)}
									popupClassName="input-tag"
									options={bonusOptions}
								/>
							</Form.Item>
						</div>
						<div className="custom-form-group">
							<label className="bs-form-label">
								{ml(
									'Temporary Bonus Schedule',
									currentUser,
									allMultiLingualData
								)}
								{': '}
							</label>
							<Form.Item
								name="bonusSchedule"
								rules={[
									{
										required: true,
										message: 'Please select Bonus Schedule',
									},
								]}
							>
								<RangePicker
									className="ant-picker-480px-mw"
									separator={<span>~</span>}
									format="MM-DD-YYYY"
									startdateText={ml(
										'Start date',
										currentUser,
										allMultiLingualData
									)}
									enddateText={ml('End date', currentUser, allMultiLingualData)}
									maxDate={dayjs()}
									disabledDate={this.disabledDate}
									onChange={(value) => this.handleDateRangeFilter(value)}
								/>
							</Form.Item>
						</div>
					</div>
				</div>
			</Form>
		);
	};

	cancelEdit = () => {
		message.error('Edit Cancelled');
		this.setState({
			edit: false,
			editJobReq: false,
			editBonusScheduleReq: false,
		});
	};

	comparer(otherArray) {
		return function (current) {
			return (
				otherArray.filter(function (other) {
					return other.id === current.id;
				}).length === 0
			);
		};
	}

	/*
	 * A campaign's tiered bonus replaces the job's own for the length of the campaign,
	 * and only tiers matching an employee's user group are ever paid. Picking a bonus
	 * that has no tier for a group means those employees see the job's own bonus
	 * instead — or nothing at all, if the job has no bonus of its own for
	 * resolveActiveTieredBonus to fall back to. Confirm before saving either way.
	 * Narrow campaigns can be deliberate (a Japan-only promo), which is why this asks
	 * rather than blocks. Runs on create AND edit: repointing an existing campaign is
	 * how the original Syneos mix-up would most likely be repeated. (ERIN-7863)
	 */
	confirmUncoveredUserGroups = (
		tieredBonusId,
		{ okText = 'Create anyway', jobs = [] } = {}
	) => {
		const { userGroups = [] } = this.props;
		const bonus = get(this.state, 'bonuses', []).find(
			(item) => item.id === tieredBonusId
		);
		const activeGroups = userGroups.filter((group) => group.active !== false);
		if (!bonus || activeGroups.length === 0) return true;

		const uncovered = uncoveredUserGroups(bonus, activeGroups);
		if (uncovered.length === 0) return true;

		const names = uncovered.map((group) => group.name).sort();
		const shown = names.slice(0, 10);
		const bonuslessJobs = jobsMissingOwnTieredBonus(jobs);
		const bonuslessTitles = bonuslessJobs
			.map((job) => get(job, 'title'))
			.filter(Boolean)
			.sort();
		const shownJobs = bonuslessTitles.slice(0, 5);
		return new Promise((resolve) => {
			Modal.confirm({
				title: `"${bonus.name}" has no bonus tier for ${uncovered.length} of your ${activeGroups.length} user groups`,
				content: (
					<div>
						<div>
							Employees in these groups will not see this campaign's bonus on
							the selected jobs while it is running:
						</div>
						<ul style={{ margin: '8px 0 0 20px' }}>
							{shown.map((name) => (
								<li key={name}>{name}</li>
							))}
						</ul>
						{names.length > shown.length && (
							<div>…and {names.length - shown.length} more.</div>
						)}
						{bonuslessJobs.length > 0 && (
							<div style={{ marginTop: 12 }}>
								<div>
									{bonuslessJobs.length === 1
										? 'This job has no referral bonus of its own, so those employees will see no bonus at all:'
										: `${bonuslessJobs.length} of the selected jobs have no referral bonus of their own, so those employees will see no bonus at all:`}
								</div>
								<ul style={{ margin: '8px 0 0 20px' }}>
									{shownJobs.map((title) => (
										<li key={title}>{title}</li>
									))}
								</ul>
								{bonuslessTitles.length > shownJobs.length && (
									<div>
										…and {bonuslessTitles.length - shownJobs.length} more.
									</div>
								)}
							</div>
						)}
					</div>
				),
				okText,
				cancelText: 'Go back and change the bonus',
				width: 520,
				onOk: () => resolve(true),
				onCancel: () => resolve(false),
			});
		});
	};

	createCampaign = async (e) => {
		e.preventDefault();
		const { onCreateCampaign, currentUser, onUpdateJob } = this.props;
		const {
			jobsCount,
			dateRangeFilterValue,
			selectedJobsByUser,
			filteredJobs,
		} = this.state;

		if (jobsCount === 0) {
			this.setState({
				jobError: true,
			});
		} else {
			this.setState({
				jobError: false,
			});
		}

		// Check for campaign conflicts
		const conflicts = this.checkForCampaignConflicts(filteredJobs);
		if (conflicts.length > 0) {
			const conflictMessages = conflicts.map(
				(conflict) =>
					`${conflict.jobTitle} is already in campaign(s): ${conflict.campaigns.map((c) => c.name).join(', ')}`
			);

			message.error({
				content: (
					<div>
						<div>
							The following jobs are already in active or upcoming campaigns:
						</div>
						<ul style={{ margin: '8px 0 0 20px', listStyle: 'none' }}>
							{conflictMessages.map((msg, idx) => (
								<li key={idx}>{msg}</li>
							))}
						</ul>
					</div>
				),
				duration: 8,
			});

			return;
		}

		try {
			const values = await this.bonusFormRef.current.validateFields();

			if (this.state.jobError) {
				return;
			}

			if (values.scheduleName && values.scheduleName.length > 60) {
				message.error('Schedule Name cannot be more than 60 characters');
				return;
			}

			this.setState({
				btnDisabled: true,
			});
			const jobIds = filteredJobs;
			let scheduleName = '';
			let tieredBonusId = '';
			let startDate = '';
			let endDate = '';

			if (get(values, 'scheduleName')) {
				scheduleName = get(values, 'scheduleName');
			}

			if (get(values, 'tieredBonus')) {
				tieredBonusId = get(values, 'tieredBonus');
			}

			if (
				!(await this.confirmUncoveredUserGroups(tieredBonusId, {
					jobs: selectedJobsByUser,
				}))
			) {
				this.setState({ btnDisabled: false });
				return;
			}

			if (dateRangeFilterValue.length > 0 && dateRangeFilterValue[1] !== null) {
				startDate = dateRangeFilterValue[0];
				endDate = dateRangeFilterValue[1];
			}

			const campaignInput = {
				input: {
					companyId: get(currentUser, 'companyId'),
					endDate,
					name: scheduleName,
					startDate,
					tieredBonusId,
					makeHotJob: this.state.markHot,
				},
			};
			const jobs = [];

			const uniqueJobIds = [...new Set(jobIds)];
			if (uniqueJobIds.length > 0) {
				for (const item of uniqueJobIds) {
					const job = selectedJobsByUser.find((element) => {
						return element.id === item;
					});
					if (job) {
						jobs.push({ id: item, title: job.title });
					}
				}

				campaignInput.input.jobIds = JSON.stringify(jobs);
			}

			onCreateCampaign(campaignInput).then((res) => {
				const campaignId = get(res, 'data.createCampaign.id');
				for (const item of jobIds) {
					onUpdateJob({
						id: item,
						campaignId,
						isHotJob: Boolean(this.state.markHot),
					})
						.then((res) => console.log(`${item} is updated.`))
						.catch((error_) =>
							console.error('Update Job Campaign Error:', error_)
						);
				}

				this.setState({
					success: true,
					jobsCount: 0,
					btnDisabled: false,
					jobError: false,
					selectedJobsByUser: [],
					filteredJobs: [],
					filteredDepartments: [],
					filteredSubCompanies: [],
					filteredStates: [],
					filteredCountries: [],
					filteredHiringManagers: [],
					filteredCompGrades: [],
				});
				setTimeout(() => {
					this.setState({
						success: false,
					});
				}, 3000);
				message.success('Campaign is created successfully.', 5);
				this.getAllCampaignsByCompany();
				this.bonusFormRef.current.resetFields();
			});
		} catch (error) {
			console.error('Form validation failed:', error);
		}
	};

	disabledDate(current) {
		// Can not select days before today and today
		return current && current < dayjs().startOf('day');
	}

	editInfo = (campaignId, tieredBonusId) => {
		const { allCampaigns } = this.state;
		const jobs = [];
		const selectCampaigns = allCampaigns.find((item) => item.id === campaignId);
		const jobsData = JSON.parse(selectCampaigns.jobIds);
		if (jobsData) {
			for (const item of jobsData) {
				jobs.push({ value: item.id, label: item.title });
			}
		}

		this.setState({
			edit: true,
			editCampaignId: campaignId,
			editTieredBonusId: tieredBonusId,
			editedJob: jobs,
			editJobReq: false,
			editBonusScheduleReq: false,
			makeHotJob: get(selectCampaigns, 'makeHotJob'),
		});
	};

	endCampaign = async (campaignId, tieredBonusId, multiSelectDefaultValue) => {
		const { onUpdateCampaign, onUpdateJob } = this.props;
		const campaignInput = {
			id: campaignId,
			companyId: get(this.props.currentUser, 'companyId'),
			tieredBonusId,
			archived: true,
			makeHotJob: false,
		};
		onUpdateCampaign(campaignInput).then(async (res) => {
			if (multiSelectDefaultValue.length > 0) {
				for (const item of multiSelectDefaultValue) {
					onUpdateJob({
						id: item.value,
						campaignId: null,
						isHotJob: false,
					})
						.then((res) => console.log(`${item} is updated.`))
						.catch((error) =>
							console.error('Update Job Campaign Error:', error)
						);
				}
			}

			this.setState(
				{
					edit: false,
				},
				() => {
					message.success('Campaign Ended');
					this.getAllCampaignsByCompany();
				}
			);
		});
	};

	handleDateRangeFilter(value) {
		this.setState({
			dateRangeFilterValue: value,
		});
	}

	handleEditDateRangeFilter(value) {
		this.setState({
			editDateRangeFilterValue: value,
		});
	}

	handleFilterDepartment = async (department) => {
		const { filteredDepartments, cachedDepartmentJobs } = this.state;
		if (filteredDepartments.includes(department.value)) return;

		if (!cachedDepartmentJobs[department.value]) {
			const jobIds = await this.fetchJobsByDepartmentId(department.value);
			const nextCache = { ...cachedDepartmentJobs, [department.value]: jobIds };
			const updated = [...filteredDepartments, department.value];
			this.setState(
				{ cachedDepartmentJobs: nextCache, filteredDepartments: updated },
				() => this.updateFilterJobs()
			);
		} else {
			const updated = [...filteredDepartments, department.value];
			this.updateFilterJobs({ filteredDepartments: updated });
			this.setState({
				filteredDepartments: updated,
			});
		}
	};

	handleFilterJobs = async (jobOption) => {
		const { filteredJobs } = this.state;
		if (filteredJobs.includes(jobOption.value)) return;
		const selectedJobs = get(this.state, 'allJobs', []).filter(
			(item) => item.id === jobOption.value
		);

		const { onlySelectedJobs } = this.state;
		const newOnlySelectedJobs = [...onlySelectedJobs, ...selectedJobs];

		this.setState(
			{
				onlySelectedJobs: newOnlySelectedJobs,
			},
			() => this.updateFilterJobs()
		);

		this.setState({
			disabled: false,
			jobError: false,
		});
	};

	handleFilterSubCompany = async (subCompany) => {
		const { filteredSubCompanies, cachedSubCompanyJobs } = this.state;
		if (filteredSubCompanies.includes(subCompany.value)) return;

		if (!cachedSubCompanyJobs[subCompany.value]) {
			const jobIds = await this.fetchJobsBySubCompanyId(subCompany.value);
			const nextCache = { ...cachedSubCompanyJobs, [subCompany.value]: jobIds };
			const updated = [...filteredSubCompanies, subCompany.value];
			this.setState(
				{ cachedSubCompanyJobs: nextCache, filteredSubCompanies: updated },
				() => this.updateFilterJobs()
			);
		} else {
			const updated = [...filteredSubCompanies, subCompany.value];
			this.updateFilterJobs({ filteredSubCompanies: updated });
			this.setState({
				filteredSubCompanies: updated,
			});
		}
	};

	/*
	 * Shared by the four location/manager/grade filters, which use antd's single onChange with the
	 * whole value array rather than the onSelect/onDeselect pairs the older filters above use.
	 */
	handleFilterFacet = (key, values) => {
		this.setState({ [key]: values, jobError: false }, () =>
			this.updateFilterJobs()
		);
	};

	handleHotJobs = (value) => {
		this.setState({
			markHot: value.target.checked,
		});
	};

	handleRemoveFilter = (department) => {
		const { filteredDepartments } = this.state;
		const index = filteredDepartments.indexOf(department.value);
		const filterDepartments = (item) => item !== filteredDepartments[index];
		const departments =
			filteredDepartments.length === 1
				? []
				: filteredDepartments.filter(filterDepartments);
		this.updateFilterJobs({ filteredDepartments: departments });
		this.setState({
			filteredDepartments: departments,
		});
	};
	handleRemoveJobsFilter = (jobOption) => {
		const { selectedJobsByUser, filteredJobs, onlySelectedJobs } = this.state;
		const allSelectedJobs = selectedJobsByUser.filter(
			(item) => item.id !== jobOption.value
		);

		const updatedOnlySelectedJobs = onlySelectedJobs.filter(
			(item) => item.id !== jobOption.value
		);

		this.setState(
			{
				selectedJobsByUser: allSelectedJobs,
				onlySelectedJobs: updatedOnlySelectedJobs,
			},
			() => this.updateFilterJobs()
		);
		// updateFilterJobs recomputes filteredJobs itself, so only the button state is set here.
		this.setState({
			disabled: filteredJobs.length === 1,
		});
	};
	handleRemoveSelect = (jobOption) => {
		const { editedJob } = this.state;
		const values = editedJob.filter(
			(item) => !item.value || item.value !== jobOption.value
		);
		this.setState({
			editedJob: values,
		});
	};

	handleRemoveSubCompanyFilter = (subCompany) => {
		const { filteredSubCompanies } = this.state;
		const index = filteredSubCompanies.indexOf(subCompany.value);
		const filterSubCompanies = (item) => item !== filteredSubCompanies[index];
		const subCompanies =
			filteredSubCompanies.length === 1
				? []
				: filteredSubCompanies.filter(filterSubCompanies);

		this.updateFilterJobs({ filteredSubCompanies: subCompanies });

		this.setState({
			filteredSubCompanies: subCompanies,
		});
	};

	handleSelect = (jobOption) => {
		const { editedJob } = this.state;
		const editedJobReduced = editedJob.reduce((acc, item) => {
			if (
				item.value &&
				item.label &&
				!acc.some((el) => el.value === item.value)
			) {
				acc.push(item);
			}

			return acc;
		}, []);

		const values = [...editedJobReduced, jobOption];
		this.setState({ editedJob: values });
	};

	handleSelectEditTieredBonus = (bonusOption) => {
		this.setState({
			editTieredBonusId: bonusOption.value,
		});
	};

	parseCSVLine = (line) => {
		const result = [];
		let current = '';
		let inQuotes = false;

		for (let i = 0; i < line.length; i++) {
			const char = line[i];
			const nextChar = line[i + 1];

			if (char === '"') {
				if (inQuotes && nextChar === '"') {
					// Escaped quote
					current += '"';
					i++; // Skip next quote
				} else {
					// Toggle quote state
					inQuotes = !inQuotes;
				}
			} else if (char === ',' && !inQuotes) {
				// Field separator
				result.push(current);
				current = '';
			} else {
				// Regular character
				current += char;
			}
		}

		// Push last field
		result.push(current);

		return result;
	};

	parseCSV = (file) => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.onload = (e) => {
				try {
					const text = e.target.result;

					// Split by newlines but handle quoted fields that may contain newlines
					const rows = [];
					let currentRow = '';
					let inQuotes = false;

					for (let i = 0; i < text.length; i++) {
						const char = text[i];
						const nextChar = text[i + 1];

						if (char === '"') {
							currentRow += char;
							if (inQuotes && nextChar === '"') {
								// Escaped quote
								currentRow += nextChar;
								i++; // Skip next quote
							} else {
								// Toggle quote state
								inQuotes = !inQuotes;
							}
						} else if (
							(char === '\n' || (char === '\r' && nextChar === '\n')) &&
							!inQuotes
						) {
							// End of row
							if (currentRow.trim()) {
								rows.push(currentRow.trim());
							}
							currentRow = '';
							if (char === '\r') i++; // Skip \n in \r\n
						} else {
							currentRow += char;
						}
					}

					// Add last row if exists
					if (currentRow.trim()) {
						rows.push(currentRow.trim());
					}

					if (rows.length === 0) {
						reject(new Error('CSV file is empty'));
						return;
					}

					// Parse header row
					const headers = this.parseCSVLine(rows[0]);

					// Parse data rows
					const data = [];
					for (let i = 1; i < rows.length; i++) {
						const values = this.parseCSVLine(rows[i]);
						const row = {};
						headers.forEach((header, index) => {
							row[header] = values[index] || '';
						});
						data.push(row);
					}

					resolve({ headers, data });
				} catch (error) {
					reject(error);
				}
			};
			reader.onerror = () => reject(new Error('Failed to read file'));
			reader.readAsText(file);
		});
	};

	handleCSVUpload = async (info) => {
		const { file } = info;

		if (file.status === 'done' || !file.status) {
			try {
				const actualFile = file.originFileObj || file;
				const { headers, data } = await this.parseCSV(actualFile);

				const columnOptions = headers.map((header) => ({
					value: header,
					label: header,
				}));

				this.setState({
					csvFile: actualFile,
					csvColumns: columnOptions,
					csvParsedData: data,
					selectedColumn: null,
				});

				message.success('CSV uploaded successfully');
			} catch (error) {
				message.error(`Error parsing CSV: ${error.message}`);
				this.setState({
					csvFile: null,
					csvColumns: [],
					csvParsedData: [],
					selectedColumn: null,
				});
			}
		}
	};

	handleColumnSelect = (value) => {
		this.setState({
			selectedColumn: value,
		});
	};

	handleFindMatchingJobs = async () => {
		const { csvParsedData, selectedColumn, subCompanies, includeClosedJobs } =
			this.state;
		const { client, currentUser, departments = [] } = this.props;

		if (!selectedColumn) {
			message.warning('Please select a column');
			return;
		}

		const reqIds = csvParsedData
			.map((row) => {
				const value = row[selectedColumn];
				return value ? value.trim() : null;
			})
			.filter((value) => value !== null && value !== '');

		const uniqueReqIds = [...new Set(reqIds)];

		const limitedReqIds =
			uniqueReqIds.length > 2500 ? uniqueReqIds.slice(0, 2500) : uniqueReqIds;

		this.setState({ csvJobsLoading: true });

		try {
			const { data } = await client.query({
				query: QUERY_JOBS_BY_COMPANY_ID_EXTERNAL_IDS,
				variables: {
					companyId: get(currentUser, 'companyId'),
					externalJobIds: limitedReqIds,
					includeClosedJobs: includeClosedJobs,
				},
				fetchPolicy: 'network-only',
			});

			const matchedJobs = get(
				data,
				'queryJobsByCompanyIdExternalIds.items',
				[]
			);

			if (matchedJobs.length === 0) {
				message.warning('No matching jobs found for the provided Req Ids');
				this.setState({ csvJobsLoading: false });
				return;
			}

			const enrichedJobs = matchedJobs.map((job) => {
				const department = departments.find(
					(dept) => dept.id === job.departmentId
				);
				const subCompany = subCompanies.find(
					(sc) => sc.id === job.subCompanyId
				);

				return {
					...job,
					department: department || null,
					subCompany: subCompany || null,
				};
			});

			const jobIds = enrichedJobs.map((job) => job.id);

			this.setState(
				{
					selectedJobsByUser: enrichedJobs,
					filteredJobs: jobIds,
					onlySelectedJobs: enrichedJobs,
					jobsCount: enrichedJobs.length,
					jobError: false,
					disabled: false,
					csvJobsLoading: false,
				},
				() => {
					message.success(
						`Successfully matched ${enrichedJobs.length} job(s) from ${limitedReqIds.length} Req Id(s)`
					);
				}
			);
		} catch (error) {
			console.error('Error fetching jobs by Req Id(s):', error);
			message.error('Failed to fetch matching jobs. Please try again.');
			this.setState({ csvJobsLoading: false });
		}
	};

	openUpdateCsvModal = (campaign) => {
		this.setState({
			updateCsvModalVisible: true,
			updateCsvCampaign: campaign,
			updateCsvFile: null,
			updateCsvColumns: [],
			updateCsvSelectedColumn: null,
			updateCsvParsedData: [],
			updateCsvJobsLoading: false,
			updateCsvIncludeClosedJobs: false,
			updateCsvNewJobs: [],
			updateCsvExistingJobs: [],
			updateCsvRemovedJobs: [],
			updateCsvResultsReady: false,
			updateCsvMarkHot: false,
			updateCsvRemoveJobs: false,
			updateCsvUpdating: false,
		});
	};

	closeUpdateCsvModal = () => {
		this.setState({
			updateCsvModalVisible: false,
			updateCsvCampaign: null,
		});
	};

	handleUpdateCsvUpload = async (info) => {
		const file = info.file;
		if (file.status === 'removed') return;

		try {
			const actualFile = file.originFileObj || file;
			const { headers, data } = await this.parseCSV(actualFile);

			const columns = headers.map((h) => ({ value: h, label: h }));

			this.setState({
				updateCsvFile: actualFile,
				updateCsvColumns: columns,
				updateCsvParsedData: data,
				updateCsvSelectedColumn: null,
				updateCsvResultsReady: false,
				updateCsvNewJobs: [],
				updateCsvExistingJobs: [],
				updateCsvRemovedJobs: [],
			});
		} catch (error) {
			console.error('Error parsing CSV:', error);
			message.error('Failed to parse CSV file. Please try again.');
		}
	};

	handleUpdateCsvFindJobs = async () => {
		const {
			updateCsvParsedData,
			updateCsvSelectedColumn,
			updateCsvIncludeClosedJobs,
			updateCsvCampaign,
		} = this.state;
		const { client, currentUser } = this.props;

		if (!updateCsvSelectedColumn) {
			message.warning('Please select a column');
			return;
		}

		const reqIds = updateCsvParsedData
			.map((row) => {
				const value = row[updateCsvSelectedColumn];
				return value ? value.trim() : null;
			})
			.filter((value) => value !== null && value !== '');

		const uniqueReqIds = [...new Set(reqIds)];
		const limitedReqIds =
			uniqueReqIds.length > 2500 ? uniqueReqIds.slice(0, 2500) : uniqueReqIds;

		this.setState({ updateCsvJobsLoading: true });

		try {
			const { data } = await client.query({
				query: QUERY_JOBS_BY_COMPANY_ID_EXTERNAL_IDS,
				variables: {
					companyId: get(currentUser, 'companyId'),
					externalJobIds: limitedReqIds,
					includeClosedJobs: updateCsvIncludeClosedJobs,
				},
				fetchPolicy: 'network-only',
			});

			const matchedJobs = get(
				data,
				'queryJobsByCompanyIdExternalIds.items',
				[]
			);

			// Deduplicate by id
			const uniqueMatchedJobs = _.uniqBy(matchedJobs, 'id');
			const foundJobIds = uniqueMatchedJobs.map((job) => job.id);

			// Parse current campaign job ids
			const campaignJobs = JSON.parse(updateCsvCampaign.jobIds || '[]');
			const campaignJobIds = campaignJobs.map((j) => j.id);

			// Array 1: Found jobs NOT already in campaign (new)
			const newJobs = foundJobIds.filter((id) => !campaignJobIds.includes(id));
			// Array 2: Found jobs already in campaign (existing)
			const existingJobs = foundJobIds.filter((id) =>
				campaignJobIds.includes(id)
			);
			// Array 3: Campaign jobs NOT in found jobs (removed)
			const removedJobs = campaignJobIds.filter(
				(id) => !foundJobIds.includes(id)
			);

			this.setState({
				updateCsvJobsLoading: false,
				updateCsvResultsReady: true,
				updateCsvNewJobs: newJobs,
				updateCsvExistingJobs: existingJobs,
				updateCsvRemovedJobs: removedJobs,
				updateCsvFoundJobs: uniqueMatchedJobs,
			});
		} catch (error) {
			console.error('Error fetching jobs by Req Id(s):', error);
			message.error('Failed to fetch matching jobs. Please try again.');
			this.setState({ updateCsvJobsLoading: false });
		}
	};

	handleUpdateCsvSubmit = async () => {
		const {
			updateCsvCampaign,
			updateCsvNewJobs,
			updateCsvExistingJobs,
			updateCsvRemovedJobs,
			updateCsvRemoveJobs,
			updateCsvMarkHot,
			updateCsvFoundJobs,
		} = this.state;
		const { onUpdateCampaign, onUpdateJob } = this.props;

		if (updateCsvRemoveJobs && updateCsvRemovedJobs.length > 0) {
			Modal.confirm({
				title: 'Are you sure?',
				content: `Are you sure you want to remove jobs not included in the CSV? This will remove ${updateCsvRemovedJobs.length} jobs from the current campaign.`,
				okText: 'Yes',
				cancelText: 'No',
				onOk: () => this.executeUpdateCsvCampaign(),
			});
		} else {
			this.executeUpdateCsvCampaign();
		}
	};

	executeUpdateCsvCampaign = async () => {
		const {
			updateCsvCampaign,
			updateCsvNewJobs,
			updateCsvExistingJobs,
			updateCsvRemovedJobs,
			updateCsvRemoveJobs,
			updateCsvMarkHot,
			updateCsvFoundJobs,
		} = this.state;
		const { onUpdateCampaign, onUpdateJob } = this.props;

		this.setState({ updateCsvUpdating: true });

		try {
			// Build the new jobIds array for the campaign
			const currentJobs = JSON.parse(updateCsvCampaign.jobIds || '[]');

			// Start with existing campaign jobs
			let updatedJobs = [...currentJobs];

			// Add new jobs from CSV
			const newJobObjects = updateCsvNewJobs.map((id) => {
				const foundJob = updateCsvFoundJobs.find((j) => j.id === id);
				return { id, title: foundJob?.title || '' };
			});
			updatedJobs = [...updatedJobs, ...newJobObjects];

			// Remove jobs not in CSV if checkbox is checked
			if (updateCsvRemoveJobs) {
				updatedJobs = updatedJobs.filter(
					(job) => !updateCsvRemovedJobs.includes(job.id)
				);
			}

			// Deduplicate
			updatedJobs = _.uniqBy(updatedJobs, 'id');

			const campaignInput = {
				id: updateCsvCampaign.id,
				companyId: get(this.props.currentUser, 'companyId'),
				tieredBonusId: updateCsvCampaign.tieredBonusId,
				jobIds: JSON.stringify(updatedJobs),
			};

			await onUpdateCampaign(campaignInput);

			// Update new jobs with campaignId and hot job status
			for (const jobId of updateCsvNewJobs) {
				try {
					await onUpdateJob({
						id: jobId,
						campaignId: updateCsvCampaign.id,
						isHotJob: Boolean(updateCsvMarkHot),
					});
				} catch (error) {
					console.error('Update Job Campaign Error:', error);
				}
			}

			// If removing jobs, update those jobs to remove campaignId
			if (updateCsvRemoveJobs && updateCsvRemovedJobs.length > 0) {
				for (const jobId of updateCsvRemovedJobs) {
					try {
						await onUpdateJob({
							id: jobId,
							campaignId: null,
						});
					} catch (error) {
						console.error('Remove Job Campaign Error:', error);
					}
				}
			}

			message.success('Campaign updated successfully.');
			this.setState({
				updateCsvModalVisible: false,
				updateCsvCampaign: null,
				updateCsvUpdating: false,
			});
			this.getAllCampaignsByCompany();
		} catch (error) {
			console.error('Error updating campaign:', error);
			message.error('Failed to update campaign. Please try again.');
			this.setState({ updateCsvUpdating: false });
		}
	};

	headers = [
		{ label: 'First Name', key: 'firstName' },
		{ label: 'Last Name', key: 'lastName' },
		{ label: 'Candidate Email', key: 'candidateEmail' },
	];

	/*
	 * One of the four bulk filters derived from the job list itself. Rendered like the Subcompany
	 * and Department filters above: always present, and disabled until every job has loaded, since
	 * both the options and the resulting job counts are computed from the full list.
	 */
	renderFacetFilter = ({ name, label, options, stateKey }) => {
		const { currentUser, allMultiLingualData } = this.props;
		const { jobsLoading } = this.state;

		return (
			<div className="custom-form-group">
				<label className="bs-form-label">
					{ml(label, currentUser, allMultiLingualData)}:
				</label>
				<div className="custom-form-green-select">
					<Form.Item name={name}>
						<Select
							showSearch
							filterOption={(input, option) =>
								option.label?.toLowerCase()?.includes(input.toLowerCase())
							}
							className="custom-input"
							mode="multiple"
							placeholder={ml('All', currentUser, allMultiLingualData)}
							popupClassName="input-tag"
							options={options}
							disabled={jobsLoading}
							onChange={(values) => this.handleFilterFacet(stateKey, values)}
						/>
					</Form.Item>
				</div>
			</div>
		);
	};

	selectJobs = () => {
		const { departments = [] } = this.props;
		const {
			allJobs = [],
			subCompanies = [],
			stateOptions = [],
			countryOptions = [],
			hiringManagerOptions = [],
			compGradeOptions = [],
			jobsLoading = false,
		} = this.state;
		const { currentUser, allMultiLingualData } = this.props;
		// Hiring Manager and Compensation Grade are opt-in per company, same gate as Browse Jobs.
		const jobFilterSettings =
			parse(get(currentUser, 'company.jobFilterSettings')) || {};

		const sortedJobs = _.sortBy(allJobs, function (job) {
			return job.title;
		});

		const sortedDepartments = _.sortBy(departments, ['name']).filter(
			(department) => department?.active
		);

		const departmentOptions = sortedDepartments.map((department) => {
			return { value: department.id, label: department.name };
		});

		const jobsOptions = sortedJobs.map((job) => {
			return {
				value: job.id,
				label: `${job.title}, (req: ${
					job.externalJobId ? job.externalJobId : 'N/A'
				})`,
			};
		});
		const brandsOptions = [];
		brandsOptions.push({ value: 1, label: 'Main Logo (Default)' });
		let sortedSubCompanies = [];
		if (subCompanies.length > 0) {
			sortedSubCompanies = _.sortBy(subCompanies, ['name']);
		}

		sortedSubCompanies.map((brand) => {
			brandsOptions.push({ value: brand.id, label: brand.name });
		});

		const subCompanyOptions = sortedSubCompanies.map((subCompany) => {
			return { value: subCompany.id, label: subCompany.name };
		});

		return (
			<Form ref={this.jobsFormRef}>
				<h4 className="campaign-title">
					Step 1. {ml('Select Jobs', currentUser, allMultiLingualData)}
				</h4>
				<p className="campaign-subtitle">
					{ml(
						'Include jobs in the email and have the option to change their bonuses in the next step',
						currentUser,
						allMultiLingualData
					)}
				</p>
				<div className="campaign-form-wrap">
					<div className="bs-form">
						<Tabs
							defaultActiveKey="manual"
							items={[
								{
									key: 'manual',
									label: 'Manual',
									children: (
										<>
											<div className="custom-form-group">
												<label className="bs-form-label">
													{ml(
														'Select Individual Job(s)',
														currentUser,
														allMultiLingualData,
														'Bonus Campaign'
													)}
													:
												</label>
												<div className="custom-form-green-select">
													<Form.Item name="jobIds">
														<Select
															labelInValue
															showSearch
															dropdownMatchSelectWidth
															className="custom-input"
															filterOption={(input, option) => {
																return option.label
																	?.toLowerCase()
																	?.includes(input.toLowerCase());
															}}
															placeholder="None"
															mode="multiple"
															popupClassName="input-tag"
															options={jobsOptions}
															loading={jobsLoading}
															onSelect={(jobOption) =>
																this.handleFilterJobs(jobOption)
															}
															onDeselect={(jobOption) =>
																this.handleRemoveJobsFilter(jobOption)
															}
														/>
													</Form.Item>
												</div>
												{this.state.jobError && (
													<div className="input-error">
														Please Select Job(s) Or bulk select job with
														Subcompany and Department filters
													</div>
												)}
											</div>
											<p>
												{ml(
													'and / or bulk select jobs with these filters',
													currentUser,
													allMultiLingualData
												)}
												:
											</p>
											{jobsLoading && (
												<div
													className="custom-form-group"
													style={{
														display: 'flex',
														alignItems: 'center',
														gap: 8,
													}}
												>
													<Spin size="small" />
													<span>
														Loading jobs… {allJobs.length.toLocaleString()}{' '}
														loaded so far. Filters unlock once every job has
														loaded.
													</span>
												</div>
											)}
											<div className="custom-form-group">
												<label className="bs-form-label">
													{ml(
														'Jobs in Subcompany',
														currentUser,
														allMultiLingualData
													)}
													:
												</label>
												<div className="custom-form-green-select">
													<Form.Item name="subComp">
														<Select
															labelInValue
															filterOption={(input, option) => {
																return option.label
																	.toLowerCase()
																	.includes(input.toLowerCase());
															}}
															className="custom-input"
															mode="multiple"
															placeholder={ml(
																'All',
																currentUser,
																allMultiLingualData
															)}
															popupClassName="input-tag"
															options={subCompanyOptions}
															disabled={jobsLoading}
															onSelect={(subCompany) =>
																this.handleFilterSubCompany(subCompany)
															}
															onDeselect={(subCompany) =>
																this.handleRemoveSubCompanyFilter(subCompany)
															}
														/>
													</Form.Item>
												</div>
											</div>
											<div className="custom-form-group">
												<label className="bs-form-label">
													{ml(
														'and in Departments',
														currentUser,
														allMultiLingualData
													)}
													:
												</label>
												<div className="custom-form-green-select">
													<Form.Item name="dept">
														<Select
															labelInValue
															filterOption={(input, option) => {
																return option.label
																	.toLowerCase()
																	.includes(input.toLowerCase());
															}}
															className="custom-input"
															mode="multiple"
															placeholder={ml(
																'All',
																currentUser,
																allMultiLingualData
															)}
															popupClassName="input-tag"
															options={departmentOptions}
															disabled={jobsLoading}
															onSelect={(department) =>
																this.handleFilterDepartment(department)
															}
															onDeselect={(department) =>
																this.handleRemoveFilter(department)
															}
														/>
													</Form.Item>
												</div>
											</div>
											{this.renderFacetFilter({
												name: 'workState',
												label: 'and in Work State/Province',
												options: stateOptions,
												stateKey: 'filteredStates',
											})}
											{this.renderFacetFilter({
												name: 'workCountry',
												label: 'and in Country',
												options: countryOptions,
												stateKey: 'filteredCountries',
											})}
											{jobFilterSettings?.hiringManager?.hidden === false &&
												this.renderFacetFilter({
													name: 'hiringManager',
													label: 'and with Hiring Manager',
													options: hiringManagerOptions,
													stateKey: 'filteredHiringManagers',
												})}
											{jobFilterSettings?.compensationGrade?.hidden === false &&
												this.renderFacetFilter({
													name: 'compensationGrade',
													label: 'and in Compensation Grade',
													options: compGradeOptions,
													stateKey: 'filteredCompGrades',
												})}
										</>
									),
								},
								{
									key: 'csv',
									label: 'Upload CSV',
									children: (
										<>
											<div className="custom-form-group">
												<p style={{ marginBottom: 16 }}>
													Upload a CSV and select the column that maps to the
													Req Id for your jobs (Limit: 2500)
												</p>
												<Upload
													accept=".csv"
													maxCount={1}
													beforeUpload={() => false}
													onChange={this.handleCSVUpload}
													onRemove={() => {
														this.setState({
															csvFile: null,
															csvColumns: [],
															csvParsedData: [],
															selectedColumn: null,
														});
													}}
												>
													<Button type="primary">Upload CSV</Button>
												</Upload>
											</div>
											{this.state.csvColumns.length > 0 && (
												<>
													<div className="custom-form-group">
														<label className="bs-form-label">
															Select Req Id Column:
														</label>
														<Select
															className="custom-input"
															placeholder="Select column"
															options={this.state.csvColumns}
															value={this.state.selectedColumn}
															onChange={this.handleColumnSelect}
															style={{ width: '100%' }}
														/>
													</div>
													<div className="custom-form-group">
														<Button
															type="primary"
															disabled={!this.state.selectedColumn}
															loading={this.state.csvJobsLoading}
															onClick={this.handleFindMatchingJobs}
															style={{ marginRight: 12 }}
														>
															Find Matching Jobs
														</Button>
														<label
															style={{
																display: 'inline-flex',
																alignItems: 'center',
																gap: 4,
																minWidth: 'auto',
																lineHeight: 'normal',
																alignSelf: 'center',
															}}
														>
															<input
																type="checkbox"
																checked={this.state.includeClosedJobs}
																onChange={(e) =>
																	this.setState({
																		includeClosedJobs: e.target.checked,
																	})
																}
															/>
															Include Closed Jobs
														</label>
													</div>
												</>
											)}
										</>
									),
								},
							]}
						/>
						<div className="custom-form-group custom-checkbox">
							<input
								type="checkbox"
								id="markJobs"
								onChange={this.handleHotJobs}
							/>
							<label className="bs-form-label" htmlFor="markJobs">
								{ml(
									'Mark Job(s) As Hot Job(s)',
									currentUser,
									allMultiLingualData,
									'Bonus Campaign'
								)}
								:
							</label>
						</div>
						<div className="jobs-selected-wrap" style={{ marginBottom: 24 }}>
							<div className="jobs-selected">
								{this.state.loaded ? (
									<Spinner height={50} width={50} color={COLORS.darkBlue2} />
								) : (
									<span style={{ fontWeight: 700 }}>
										{this.state.jobsCount}&nbsp;
									</span>
								)}
								{ml('Jobs Selected', currentUser, allMultiLingualData)}
							</div>
							<CSVLink
								filename="jobs.csv"
								data={this.getJobsCSVData()}
								headers={this.JobsCsvheader}
								className="download-link"
								style={{ fontWeight: 700 }}
							>
								{ml('Download List', currentUser, allMultiLingualData)}
							</CSVLink>
						</div>
					</div>
				</div>
			</Form>
		);
	};

	updateCampaign = async (
		campaignId = null,
		tieredBonusId = null,
		job = null,
		multiSelectDefaultValue = null
	) => {
		const {
			editedJob,
			editCampaignId,
			editTieredBonusId,
			editDateRangeFilterValue,
		} = this.state;
		const errors = [];
		const { onUpdateCampaign, onUpdateJob, client } = this.props;
		const campaignInput = {
			id: editCampaignId === null ? campaignId : editCampaignId,
			companyId: get(this.props.currentUser, 'companyId'),
			tieredBonusId:
				editTieredBonusId === null ? tieredBonusId : editTieredBonusId,
			archived: false,
		};
		const jobs = [];
		let jobData = [];
		let selectedValues = [];
		if (job !== null) {
			selectedValues = multiSelectDefaultValue.filter(
				(item) => item.value !== job.value
			);
			if (selectedValues.length > 0) {
				for (const item of selectedValues) {
					jobs.push({ id: item.value, title: item.label });
				}

				campaignInput.jobIds = JSON.stringify(jobs);
			}
		} else if (editedJob.length > 0) {
			for (const item of editedJob) {
				jobs.push({ id: item.value, title: item.label });
			}

			campaignInput.jobIds = JSON.stringify(jobs);
		} else {
			errors.push('Please select Job(s).');
			this.setState({
				editJobReq: true,
			});
		}

		if (!editDateRangeFilterValue?.length) {
			errors.push('Please select Bonus Schedule.');
			this.setState({
				editBonusScheduleReq: true,
			});
		}

		if (errors.length > 0) {
			return;
		}

		/*
		 * Repointing an existing campaign at a narrow bonus table is the same mistake as
		 * creating one, so warn here too. Skipped on the job-removal path (job !== null),
		 * which only narrows scope and leaves the bonus alone. (ERIN-7863)
		 */
		if (job === null) {
			const selectedJobs = get(this.state, 'allJobs', []).filter((item) =>
				jobs.some((selected) => selected.id === item.id)
			);
			if (
				!(await this.confirmUncoveredUserGroups(campaignInput.tieredBonusId, {
					okText: 'Save anyway',
					jobs: selectedJobs,
				}))
			) {
				return;
			}
		}

		this.setState({
			editJobReq: false,
			editBonusScheduleReq: false,
		});

		if (
			editDateRangeFilterValue?.length > 0 &&
			editDateRangeFilterValue[1] !== null
		) {
			const startDate = editDateRangeFilterValue[0];
			const endDate = editDateRangeFilterValue[1];
			campaignInput.startDate = startDate;
			campaignInput.endDate = endDate;
		}

		onUpdateCampaign(campaignInput).then(async (res) => {
			try {
				const { data } = await client.query({
					query: gql(queryJobsByCampaignIdIndex),
					variables: {
						campaignId: editCampaignId === null ? campaignId : editCampaignId,
					},
					fetchPolicy: 'network-only',
				});
				jobData = get(data, 'queryJobsByCampaignIdIndex.items', []);
			} catch (error) {
				console.log(error);
			}

			const newJobs = jobs.filter(this.comparer(jobData));
			const jobsToUpdate = jobData.filter(this.comparer(jobs));
			let makeHotJob = false;
			jobData.forEach(async (item) => {
				makeHotJob = item.isHotJob;
				await onUpdateJob({
					id: item.id,
					isHotJob: Boolean(makeHotJob),
				})
					.then((res) => console.log(`${item} is updated.`))
					.catch((error) => console.error('Update Job Campaign Error:', error));
			});
			if (newJobs.length > 0) {
				for (const item of newJobs) {
					onUpdateJob({
						id: item.id,
						campaignId: editCampaignId === null ? campaignId : editCampaignId,
						isHotJob: Boolean(makeHotJob),
					})
						.then((res) => console.log(`${item} is updated.`))
						.catch((error) =>
							console.error('Update Job Campaign Error:', error)
						);
				}
			}

			if (jobsToUpdate.length > 0) {
				for (const item of jobsToUpdate) {
					onUpdateJob({
						id: item.id,
						campaignId: null,
						isHotJob: false,
					})
						.then((res) => console.log(`${item} is updated.`))
						.catch((error) =>
							console.error('Update Job Campaign Error:', error)
						);
				}
			}

			this.setState(
				{
					edit: false,
				},
				() => {
					message.success('Campaign Edited');
					this.getAllCampaignsByCompany();
				}
			);
		});
	};

	/*
	 * Every bulk filter narrows the same candidate set: a job has to satisfy all of the filters that
	 * currently have a selection (an empty filter contributes nothing), so State + Department means
	 * "jobs in that state AND that department", not the union of the two. Jobs picked by hand in the
	 * individual-job dropdown are then added on top.
	 *
	 * Callers pass the value they just changed in `overrides`, because setState has usually not
	 * committed it yet by the time we run.
	 */
	updateFilterJobs(overrides = {}) {
		const {
			onlySelectedJobs,
			cachedDepartmentJobs,
			cachedSubCompanyJobs,
			allJobs,
			jobFacets,
			filteredDepartments,
			filteredSubCompanies,
			filteredStates,
			filteredCountries,
			filteredHiringManagers,
			filteredCompGrades,
		} = { ...this.state, ...overrides };

		const manualIds = onlySelectedJobs.map((j) => j.id);

		// Department and subcompany still resolve through the job IDs cached by their own queries.
		const idsFromCache = (selected, cache) => {
			const ids = new Set();
			(selected || []).forEach((key) => {
				(cache[key] || []).forEach((id) => ids.add(id));
			});
			return ids;
		};

		const departmentJobIds = idsFromCache(
			filteredDepartments,
			cachedDepartmentJobs
		);
		const subCompanyJobIds = idsFromCache(
			filteredSubCompanies,
			cachedSubCompanyJobs
		);

		const active = {
			departments: filteredDepartments?.length > 0,
			subCompanies: filteredSubCompanies?.length > 0,
			states: filteredStates?.length > 0,
			countries: filteredCountries?.length > 0,
			hiringManagers: filteredHiringManagers?.length > 0,
			compGrades: filteredCompGrades?.length > 0,
		};

		const bulkIds = Object.values(active).some(Boolean)
			? allJobs
					.filter((job) => {
						const facets = jobFacets[job.id] || {};
						return (
							(!active.departments || departmentJobIds.has(job.id)) &&
							(!active.subCompanies || subCompanyJobIds.has(job.id)) &&
							(!active.states || filteredStates.includes(facets.state)) &&
							(!active.countries ||
								filteredCountries.includes(facets.country)) &&
							(!active.hiringManagers ||
								filteredHiringManagers.includes(facets.hiringManagerId)) &&
							(!active.compGrades ||
								filteredCompGrades.includes(facets.compGrade))
						);
					})
					.map((job) => job.id)
			: [];

		const uniqueJobIds = [...new Set([...manualIds, ...bulkIds])];

		const selectedJobObjects = allJobs.filter((job) =>
			uniqueJobIds.includes(job.id)
		);

		this.setState({
			filteredJobs: uniqueJobIds,
			selectedJobsByUser: selectedJobObjects,
			jobsCount: uniqueJobIds.length,
		});
	}

	checkForCampaignConflicts = (selectedJobIds) => {
		const { allCampaigns } = this.state;
		const today = dayjs();
		const conflicts = [];

		selectedJobIds.forEach((jobId) => {
			// Find campaigns that include this job and have future end dates
			const conflictingCampaigns = allCampaigns.filter((campaign) => {
				if (campaign.archived) return false;

				const endDate = dayjs(campaign.endDate);
				if (endDate.isBefore(today)) return false; // Campaign already ended

				const campaignJobs = JSON.parse(campaign.jobIds || '[]');
				return campaignJobs.some((job) => job.id === jobId);
			});

			if (conflictingCampaigns.length > 0) {
				const job = this.state.selectedJobsByUser.find((j) => j.id === jobId);
				conflicts.push({
					jobId,
					jobTitle: job?.title || 'Unknown Job',
					campaigns: conflictingCampaigns.map((c) => ({
						name: c.name,
						endDate: c.endDate,
					})),
				});
			}
		});

		return conflicts;
	};

	isFutureDate = (startDate, currentDate) => {
		const start = new Date(startDate).setHours(0, 0, 0, 0);
		const current = new Date(currentDate).setHours(0, 0, 0, 0);
		return start > current;
	};

	renderBonusCampaigns = () => {
		const { allCampaigns, edit, allJobs, editCampaignId, bonuses } = this.state;
		const { allMultiLingualData, currentUser } = this.props;
		const whiteLabel = get(currentUser, 'company.whiteLabel');

		// Helper function to check if campaign is active
		const isCampaignActive = (campaign) => {
			const today = dayjs();
			const startDate = dayjs(campaign.startDate);
			const endDate = dayjs(campaign.endDate);

			if (campaign.archived) return false;

			return (
				today.isBetween(startDate, endDate, 'day', '[]') ||
				today.isBefore(startDate)
			);
		};

		// Sort campaigns - active first, then alphabetically by name
		const sortedCampaigns = _.sortBy(allCampaigns, [
			// First sort by active status (active campaigns first)
			(campaign) => !isCampaignActive(campaign),
			// Then sort by name
			'name',
		]);

		const sortedJobs = _.sortBy(allJobs, function (job) {
			return job.title;
		});

		const jobsOptions = sortedJobs.map((job) => {
			return {
				value: job.id,
				label: `${job.title}, (req: ${
					job.externalJobId ? job.externalJobId : 'N/A'
				})`,
			};
		});

		const sortedBonuses = _.sortBy(bonuses, ['name']);
		const bonusOptions = sortedBonuses.map((bonus) => {
			return { value: bonus.id, label: bonus.name };
		});

		const { RangePicker } = DatePicker;
		let editJobSelect = '';
		const okButton = (
			<div className="campaign-confirmation-btn">
				<Popconfirm
					title="Confirm Updates?"
					placement="left"
					okText="Yes"
					cancelText="No"
					onConfirm={() => this.updateCampaign()}
				>
					<Button block type="primary" size="large">
						Save
					</Button>
				</Popconfirm>
				<Popconfirm
					title="Discard edits?"
					placement="left"
					okText="Yes"
					cancelText="No"
					onConfirm={this.cancelEdit}
				>
					<Button ghost block type="primary" size="large">
						Cancel
					</Button>
				</Popconfirm>
			</div>
		);

		if (sortedCampaigns.length > 0) {
			return sortedCampaigns.map((campaign) => {
				const { name, jobIds, tieredBonusId, startDate, endDate } = campaign;
				if (!name) return null;

				let jobTitle = '';
				let temporaryBonus = '';
				let showStartDate = '';
				let showEndDate = '';
				const multiSelectDefaultValue = [];

				const jobs = JSON.parse(jobIds);
				if (jobs) {
					jobs.map((item) => {
						jobTitle = `${item.title}, (req: ${
							item.externalJobId ? item.externalJobId : 'N/A'
						})`;
						multiSelectDefaultValue.push({
							value: item.id,
							label: item.title,
						});
					});
				}

				if (editCampaignId !== null && editCampaignId === campaign.id) {
					editJobSelect = (
						<>
							<div className="custom-form-green-select">
								<Form.Item>
									<Select
										showSearch
										labelInValue
										dropdownMatchSelectWidth
										filterOption={(input, option) => {
											return option.label
												?.toLowerCase()
												?.includes(input.toLowerCase());
										}}
										defaultValue={multiSelectDefaultValue}
										showArrow={false}
										className="custom-input"
										maxTagCount={4}
										maxTagTextLength={10}
										placeholder="None"
										mode="multiple"
										options={jobsOptions}
										onSelect={(jobOption) => this.handleSelect(jobOption)}
										onDeselect={(jobOption) =>
											this.handleRemoveSelect(jobOption)
										}
									/>
								</Form.Item>
							</div>
							{this.state.editJobReq && (
								<span className="input-error">Please Select Job(s)</span>
							)}
						</>
					);
				}

				let editTemporaryBonusSelect = '';
				if (tieredBonusId) {
					const tieredBonusName = campaign?.tieredBonus.name ?? '';
					const selectedValue = {
						value: tieredBonusId,
						label: tieredBonusName,
					};
					editTemporaryBonusSelect = (
						<Form.Item>
							<Select
								labelInValue
								dropdownMatchSelectWidth
								filterOption={(input, option) => {
									return option.label
										.toLowerCase()
										.includes(input.toLowerCase());
								}}
								className="custom-input"
								defaultValue={selectedValue}
								showArrow={false}
								placeholder="Choose a Bonus"
								options={bonusOptions}
								onSelect={(bonusOption) =>
									this.handleSelectEditTieredBonus(bonusOption)
								}
							/>
						</Form.Item>
					);
				}

				const editBonusRange = (
					<>
						<Form.Item>
							<RangePicker
								className="ant-picker-480px-mw-no-bg"
								separator={<span>~</span>}
								format="MM-DD-YYYY"
								startdateText="Start date"
								enddateText="End date"
								maxDate={dayjs()}
								defaultValue={[dayjs(startDate), dayjs(endDate)]}
								onChange={(value) => this.handleEditDateRangeFilter(value)}
							/>
						</Form.Item>
						{this.state.editBonusScheduleReq && (
							<span className="input-error">Please Select Bonus Schedule</span>
						)}
					</>
				);
				const languageCode = get(currentUser, 'languageCode');
				const dateFormat = get(currentUser, 'dateFormat');
				jobTitle = jobTitle.replace(/,\s*$/, '');
				temporaryBonus = get(campaign, 'tieredBonus.name');
				const stDate = get(campaign, 'startDate');
				showStartDate = formatDate(stDate, languageCode, dateFormat);
				const edDate = get(campaign, 'endDate');
				showEndDate = formatDate(edDate, languageCode, dateFormat);
				const archived = get(campaign, 'archived', false);
				const bonusRange = `${showStartDate}` + `${' - '}` + `${showEndDate}`;
				const today = dayjs();
				const now = dayjs().startOf('day').format('YYYYMMDDHHmmss');
				const x = dayjs(now, 'YYYYMMDDHHmmss');
				const dt = x.format();
				let isActive = '';
				let isUpcoming = this.isFutureDate(stDate, dt);
				if (today.isBetween(stDate, edDate, 'day', '[]')) {
					isActive = true;
				} else if (dt < stDate && dt < edDate) {
					isActive = true;
				} else {
					isActive = false;
				}

				if (archived) {
					isActive = false;
				}

				return (
					<Collapse
						key={campaign.id + campaign.name}
						bordered={false}
						className="bonus-collapse"
						expandIconPosition="end"
					>
						<Collapse.Panel
							key={campaign.id}
							className="bonus-collapse-card"
							extra={
								<>
									<div className="ac-header-right">
										{isActive && (
											<span className="header-right-text active">
												{ml(
													isUpcoming ? 'Upcoming' : 'Active',
													currentUser,
													allMultiLingualData
												)}
											</span>
										)}
										{!isActive && (
											<span className="header-right-text">
												{ml('Complete', currentUser, allMultiLingualData)}
											</span>
										)}
									</div>
									<div className="bonus-collapse-icon-wrap">
										<i className="icon-arrow-down bonus-collapse-icon" />
									</div>
								</>
							}
							header={<h4>{campaign.name}</h4>}
						>
							<div className="campaign-details">
								<div className="campaign-left">
									{edit === true &&
									editCampaignId !== null &&
									editCampaignId === campaign.id ? (
										<div className="custom-form-group">
											<label>
												{ml('Jobs', currentUser, allMultiLingualData)}:
											</label>

											{editJobSelect}
										</div>
									) : (
										<div className="campaign-tag">
											<p className="tag-label">
												{ml('Jobs', currentUser, allMultiLingualData)}:
											</p>
											<ul className="tag-wrap">
												{this.JobItem(
													campaign.id,
													campaign.tieredBonusId,
													multiSelectDefaultValue
												)}
											</ul>
										</div>
									)}
									{edit === true &&
									editCampaignId !== null &&
									editCampaignId === campaign.id ? (
										<div className="custom-form-group">
											<label>
												{ml(
													'Temporary Bonus',
													currentUser,
													allMultiLingualData
												)}
												:
											</label>
											{editTemporaryBonusSelect}
										</div>
									) : (
										<p className="cl-details secondary">
											<span className="label">
												{ml(
													'Temporary Bonus',
													currentUser,
													allMultiLingualData
												)}
												:
											</span>
											{temporaryBonus}
										</p>
									)}
									{edit === true &&
									editCampaignId !== null &&
									editCampaignId === campaign.id ? (
										<div className="custom-form-group">
											<label>
												{ml(
													'Temporary Bonus Schedule',
													currentUser,
													allMultiLingualData
												)}
												:
											</label>
											{editBonusRange}
										</div>
									) : (
										<p className="cl-details secondary">
											<span className="label">
												{ml(
													'Temporary Bonus Schedule',
													currentUser,
													allMultiLingualData
												)}
												:
											</span>
											{bonusRange}
										</p>
									)}
									{campaign.archived ? null : (
										<Popconfirm
											title="Are you sure?"
											placement="left"
											okText="Yes"
											cancelText="No"
											onConfirm={() =>
												this.endCampaign(
													campaign.id,
													campaign.tieredBonusId,
													multiSelectDefaultValue
												)
											}
										>
											<Button type="danger" disabled={this.state.btnDisabled}>
												{ml('End Campaign', currentUser, allMultiLingualData)}
											</Button>
										</Popconfirm>
									)}
								</div>
								<div
									className="profile-actions"
									style={{
										display: 'flex',
										flexWrap: 'nowrap',
										gap: 8,
										alignItems: 'flex-start',
									}}
								>
									{edit === true &&
									editCampaignId !== null &&
									editCampaignId === campaign.id ? (
										okButton
									) : (
										<>
											<Button
												type="primary"
												onClick={() =>
													this.editInfo(campaign.id, campaign.tieredBonusId)
												}
											>
												{ml('Edit', currentUser, allMultiLingualData)}
											</Button>
											{isActive && (
												<Button
													onClick={() => this.openUpdateCsvModal(campaign)}
												>
													Upload CSV
												</Button>
											)}
										</>
									)}
								</div>
							</div>
						</Collapse.Panel>
					</Collapse>
				);
			});
		}

		if (this.loading) {
			return (
				<div className="no-content">
					<Spinner unstyled />
				</div>
			);
		}

		return (
			<div className="no-content">
				{whiteLabel ? (
					<img
						className="no-content-icon"
						src={this.state.errorImageURL}
						alt="error image"
					/>
				) : (
					<img className="no-content-icon" alt="erin-logo" src={fileIcon} />
				)}
				<p className="no-content-text">You do not have any bonus campaigns.</p>
			</div>
		);
	};

	render() {
		const { allMultiLingualData, currentUser } = this.props;
		const { subCompanies } = this.state;
		if (!get(currentUser, 'company')) return <Spinner />;
		const brandsOptions = [];
		brandsOptions.push({ value: '1', label: 'Main Logo (Default)' });
		let sortedSubCompanies = [];
		if (subCompanies.length > 0) {
			sortedSubCompanies = _.sortBy(subCompanies, ['name']);
		}

		sortedSubCompanies.map((brand) => {
			brandsOptions.push({ value: brand.id, label: brand.name });
		});

		return (
			<main>
				<div className="page-title">
					<h2 className="page-heading">
						{ml('Create A Bonus Campaign', currentUser, allMultiLingualData)}
					</h2>
				</div>
				<div className="create-bonus-campaigns">
					<div className="row">
						<div className="col-md-6">{this.selectJobs()}</div>
						<div className="col-md-6">{this.bonusSchedule()}</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							{this.state.success ? (
								<Alert
									message="Campaign created successfully."
									type="success"
								/>
							) : null}
							<Button
								type="primary"
								size="large"
								disabled={this.state.btnDisabled}
								onClick={this.createCampaign}
							>
								{ml('Create Campaign', currentUser, allMultiLingualData)}
							</Button>
						</div>
					</div>
				</div>
				<h3 className="bonus-heading">
					{ml('Bonus Campaigns', currentUser, allMultiLingualData)}
				</h3>
				<div className="bonus-campaigns">{this.renderBonusCampaigns()}</div>
				<Modal
					title="Update Jobs from CSV"
					open={this.state.updateCsvModalVisible}
					onCancel={this.closeUpdateCsvModal}
					footer={null}
					width={600}
					destroyOnClose
				>
					{this.state.updateCsvCampaign &&
						(() => {
							const hasCsv = this.state.updateCsvColumns.length > 0;
							const hasResults = this.state.updateCsvResultsReady;
							return (
								<div>
									<p>
										<strong>Campaign:</strong>{' '}
										{this.state.updateCsvCampaign.name}
									</p>
									<p>
										<strong>Current Job Count:</strong>{' '}
										{this.state.updateCsvCampaign.jobIds
											? JSON.parse(this.state.updateCsvCampaign.jobIds)?.length
											: 0}
									</p>

									<p style={{ marginTop: 16, marginBottom: 16 }}>
										Upload a CSV and select the column that maps to the Req Id
										for your jobs (Limit: 2500)
									</p>

									<Upload
										accept=".csv"
										maxCount={1}
										beforeUpload={() => false}
										onChange={this.handleUpdateCsvUpload}
										onRemove={() => {
											this.setState({
												updateCsvFile: null,
												updateCsvColumns: [],
												updateCsvParsedData: [],
												updateCsvSelectedColumn: null,
												updateCsvResultsReady: false,
												updateCsvNewJobs: [],
												updateCsvExistingJobs: [],
												updateCsvRemovedJobs: [],
											});
										}}
									>
										<Button type="primary">Upload CSV</Button>
									</Upload>

									<div className="custom-form-group" style={{ marginTop: 16 }}>
										<label className="bs-form-label">
											Select Req Id Column:
										</label>
										<Select
											className="custom-input"
											placeholder="Select column"
											disabled={!hasCsv}
											options={this.state.updateCsvColumns}
											value={this.state.updateCsvSelectedColumn}
											onChange={(value) =>
												this.setState({
													updateCsvSelectedColumn: value,
													updateCsvResultsReady: false,
												})
											}
											style={{ width: '100%' }}
										/>
									</div>
									<div className="custom-form-group">
										<Button
											type="primary"
											disabled={!hasCsv || !this.state.updateCsvSelectedColumn}
											loading={this.state.updateCsvJobsLoading}
											onClick={this.handleUpdateCsvFindJobs}
											style={{ marginRight: 12 }}
										>
											Find Matching Jobs
										</Button>
										<label
											style={{
												display: 'inline-flex',
												alignItems: 'center',
												gap: 4,
												minWidth: 'auto',
												lineHeight: 'normal',
												alignSelf: 'center',
												opacity: hasCsv ? 1 : 0.5,
											}}
										>
											<input
												type="checkbox"
												disabled={!hasCsv}
												checked={this.state.updateCsvIncludeClosedJobs}
												onChange={(e) =>
													this.setState({
														updateCsvIncludeClosedJobs: e.target.checked,
													})
												}
											/>
											Include Closed Jobs
										</label>
									</div>

									<div style={{ marginTop: 16 }}>
										<p>
											<span
												style={{
													color: hasResults ? '#52c41a' : '#d9d9d9',
													fontWeight: 700,
												}}
											>
												{hasResults ? this.state.updateCsvNewJobs.length : '-'}
											</span>
											{' - New jobs to add to campaign'}
										</p>
										<p>
											<span
												style={{
													color: hasResults ? '#faad14' : '#d9d9d9',
													fontWeight: 700,
												}}
											>
												{hasResults
													? this.state.updateCsvExistingJobs.length
													: '-'}
											</span>
											{' - Jobs already in this campaign'}
										</p>
										<p>
											<span
												style={{
													color: hasResults ? '#f5222d' : '#d9d9d9',
													fontWeight: 700,
												}}
											>
												{hasResults
													? this.state.updateCsvRemovedJobs.length
													: '-'}
											</span>
											{' - Campaign jobs not found in file'}
										</p>

										<div style={{ marginTop: 16 }}>
											<label
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: 4,
													marginBottom: 8,
													opacity: hasResults ? 1 : 0.5,
												}}
											>
												<input
													type="checkbox"
													disabled={!hasResults}
													checked={this.state.updateCsvMarkHot}
													onChange={(e) =>
														this.setState({
															updateCsvMarkHot: e.target.checked,
														})
													}
												/>
												Mark New Job(s) as Hot Job(s)
											</label>
											<label
												style={{
													display: 'flex',
													alignItems: 'center',
													gap: 4,
													marginBottom: 8,
													opacity:
														hasResults &&
														this.state.updateCsvRemovedJobs.length > 0
															? 1
															: 0.5,
												}}
											>
												<input
													type="checkbox"
													disabled={
														!hasResults ||
														this.state.updateCsvRemovedJobs.length === 0
													}
													checked={this.state.updateCsvRemoveJobs}
													onChange={(e) =>
														this.setState({
															updateCsvRemoveJobs: e.target.checked,
														})
													}
												/>
												Remove Jobs Not Included in CSV from Campaign
											</label>
										</div>

										<div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
											<Button
												type="primary"
												disabled={!hasResults}
												loading={this.state.updateCsvUpdating}
												onClick={this.handleUpdateCsvSubmit}
											>
												Update Campaign & Jobs
											</Button>
											<Button onClick={this.closeUpdateCsvModal}>Cancel</Button>
										</div>
									</div>
								</div>
							);
						})()}
				</Modal>
			</main>
		);
	}
}

export default withApollo(BonusCampaignsComponent);
